import allowDocs from '../../constant/allowDocs'

const validateFile = ({
  target,
  setImgErrorMessage,
  setDisplayImgUploadError,
  showErrorMessage,
  allowImg,
}) => {
  const content = target.files[0]
  let errorMessage = ''

  const ext = content.name.split('.').pop().toLowerCase()

  if (!allowDocs.includes(ext)) {
    setImgErrorMessage('Please upload DOCX, DOC, PDF, JPG, JPEG, PNG, BMP, or GIF images.')
    setDisplayImgUploadError(true)
    showErrorMessage()
    errorMessage = 'Image extension not allowed'
  }

  const maxFileSize = allowImg.includes(ext) ? 100000000: 10000000
  const errorSize = allowImg.includes(ext) ? '100': '10'

  if (content.size > maxFileSize) {
    setImgErrorMessage(`File size exceeds ${errorSize} MB.`)
    setDisplayImgUploadError(true)
    showErrorMessage()
    errorMessage = 'Maximum file size exceeds'
  }

  return {
    errorMessage,
    content,
    ext,
  }
}

export default validateFile
